// function determines if nav item should be rendered based on user roles
export const isNavItemRendered = (userRoles, linkRole) =>
	userRoles.some((role) => linkRole.includes(role));
